<div class="wrapper">
  <div class="popup-row popup-header-row">
    <div class="title">{{ data.title }}</div>
    @if (data?.reportDate) {
      <div class="date-chip">
        <span class="date-chip-text">{{ data.reportDate | date: 'MMM d' }}</span>
      </div>
    }
  </div>
  @if (data?.issueCard; as issue) {
    <!-- Issues tab issue (no-location list): its row cells as the Issues tab shows them -->
    <div class="popup-row">
      @if (data?.heading) {
        <div class="heading">{{ data.heading }}</div>
      }
      @if (issue.category) {
        <div class="issue-category" data-testid="issue-card-category">{{ issue.category }}</div>
      }
      @if (issue.site) {
        <div class="subheading-2 issue-site" [attr.title]="issue.site" data-testid="issue-card-site">{{ issue.site }}</div>
      }
    </div>
    <div class="popup-row issue-status-row">
      <div [ngClass]="'tone-' + issue.statusTone" class="issue-status-chip" data-testid="issue-card-status">{{ issue.statusLabel }}</div>
      @if (issue.date) {
        <div class="issue-date">{{ issue.date }}</div>
      }
    </div>
  } @else {
    <!-- Picture thumbnail preview -->
    @if (data?.type === 'picture' && data?.thumbnail) {
      <div
        class="popup-row"
        style="margin-bottom: 8px;"
        >
        <img
          [src]="data.thumbnail"
          alt="Picture preview"
          style="width: 100%; max-width: 200px; border-radius: 4px; display: block;"
          />
      </div>
    }
    <div class="popup-row">
      @if (data?.heading) {
        <div
          class="heading"
          >
          {{ data?.heading }}
        </div>
      }
      @if (data?.subheading1) {
        <div
          class="subheading-1"
          >
          {{ data?.subheading1 }}
        </div>
      }
      @if (data?.subheading2) {
        <div
          class="subheading-2"
          >
          {{ data?.subheading2 }}
        </div>
      }
    </div>
    @if (data.summary) {
      <div
        class="popup-row"
        >
        @if (data?.type === 'bid_items' || data?.type === 'deliveries') {
          <app-map-popup-summary-type-one
            [data]="data?.summary"
            />
        }
        @if (data?.type === 'quality_test' || data?.type === 'issues') {
          <app-map-popup-summary-type-two
            [data]="data?.summary"
            >
            @if (data?.type === 'issues') {
              <!-- The status pill of an issue at a contractor-workflow stage, where the open / closed badge would be -->
              <app-issue-stage-chip [issue]="data?.data?.markerData" />
            }
          </app-map-popup-summary-type-two>
        }
      </div>
    }
  }
  @if (data?.description) {
    <div
      class="description-section"
      >
      <div class="label">COMMENT</div>
      <div class="description" [class.clamp-2]="!!data?.issueCard">
        {{ data?.description }}
      </div>
    </div>
  }
  @if (data?.pictures_info) {
    <div
      class="pictures-info-section"
      >
      {{ data?.pictures_info }}
    </div>
  }
</div>
